import { canAccessAdminRoutesWithSuperAdmin, isSuperAdminRouteGuard } from '@/utils/routeGuards';

import type { RouteRecordRaw } from 'vue-router';


const routes: RouteRecordRaw[] = [
  {
    path: '/settings',
    name: 'Settings',
    component: () => import('@/views/SettingsParent.vue'),
    redirect: { name: 'SettingsScholarships' },
    children: [
      {
        path: 'scholarships/:pathMatch(.*)*',
        name: 'SettingsScholarships',
        component: () => import('@/views/SettingsScholarships.vue'),
        meta: {
          layout: 'LayoutAuthenticated',
          layoutOptions: {
            noAppBarBorder: true,
          },
          requiresAuth: true,
          title: 'pageSettings.metaTitle',
        },
        beforeEnter: [canAccessAdminRoutesWithSuperAdmin],
      },
      {
        path: 'contracts/:pathMatch(.*)*',
        name: 'SettingsContractTemplates',
        component: () => import('@/views/SettingsContractTemplates.vue'),
        meta: {
          layout: 'LayoutAuthenticated',
          layoutOptions: {
            noAppBarBorder: true,
          },
          requiresAuth: true,
          title: 'pageSettings.metaTitle',
        },
        beforeEnter: [canAccessAdminRoutesWithSuperAdmin],
      },
      {
        path: 'user-permissions/:pathMatch(.*)*',
        name: 'SettingsUserPermissions',
        component: () => import('@/views/UserPermissions.vue'),
        meta: {
          layout: 'LayoutAuthenticated',
          layoutOptions: {
            noAppBarBorder: true,
          },
          requiresAuth: true,
          title: 'pageSettings.metaTitle',
        },
        beforeEnter: [isSuperAdminRouteGuard],
      },
      {
        path: 'notifications',
        name: 'SettingsNotifications',
        component: () => import('@/views/SettingsNotifications.vue'),
        meta: {
          layout: 'LayoutAuthenticated',
          layoutOptions: {
            noAppBarBorder: true,
          },
          requiresAuth: true,
          title: 'pageSettings.metaTitle',
        },
      },
    ],
  },
];


export default routes;
